import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47910c90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "outputDialog" }

import { onBeforeMount, ref, watch } from "vue";
import PopupWindow from "@/core/popup/components/PopupWindow.vue";
import JsonTreeView from "@/flow/components/json-tree-view/JsonTreeView.vue";
import { showAlert } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { TYPE } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'OutputDataDialog',
  props: {
    dialog: { type: Boolean },
    index: {},
    outputData: {},
    path: {},
    moved: { type: Boolean },
    title: {}
  },
  emits: ["close", "setPath"],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const props = __props;

const emit = __emit;

const path = ref("");

const obj = ref({});

const initValue = ref(0);

const keyList = ref([]);

function setPath(data) {
  path.value = data.path;
  emit("setPath", data);
}
function copyJson() {
  try {
    const jsonString = props.outputData;
    navigator.clipboard
      .writeText(jsonString)
      .then(() => {
        showAlert(TYPE.SUCCESS, t("Flow.CopyJsonSuccess"));
      })
      .catch((err) => {
        showAlert(TYPE.WARNING, t("Flow.CopyJsonError"));
        console.error("Copy error:", err);
      });
  } catch (err) {
    showAlert(TYPE.WARNING, t("Flow.CopyJsonError"));
    console.error("Data formatting error:", err);
  }
}

function convertToLazyLoad() {
  if (props.outputData) {
    let jsonString = props.outputData;

    // Encapsulating numeric values inside double quotes just for UI representation.
    jsonString = jsonString.replace(
      /(?<=:\s|,\s|^\s?)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,}\]\s])/g,
      (match) => `"${match}"`
    );
    jsonString = jsonString.replace(
      /(?<=\[\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );
    jsonString = jsonString.replace(
      /(?<=,\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );
    try {
      const json = JSON.parse(jsonString);
      keyList.value = Object.keys(json);

      keyList.value
        .slice(initValue.value, initValue.value + 15)
        .forEach((key) => {
          obj.value[key] = json[key];
        });

      obj.value = JSON.stringify(obj.value);
      initValue.value += 15;
    } catch (error) {
      obj.value = props.outputData;
    }
  }
}

function addItemToObject() {
  if (props.outputData) {
    let jsonString = props.outputData;

    // Encapsulating numeric values inside double quotes just for UI representation.
    jsonString = jsonString.replace(
      /(?<=:\s|,\s|^\s?)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,}\]\s])/g,
      (match) => `"${match}"`
    );
    jsonString = jsonString.replace(
      /(?<=\[\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );
    jsonString = jsonString.replace(
      /(?<=,\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );

    try {
      const json = JSON.parse(jsonString);
      const copyObject = JSON.parse(obj.value as string);

      keyList.value
        .slice(initValue.value, initValue.value + 15)
        .forEach((key) => {
          copyObject[key] = json[key];
        });

      obj.value = JSON.stringify(copyObject);
      initValue.value += 15;
    } catch (error) {
      obj.value = props.outputData;
    }
  }
}

watch(
  () => props.path,
  () => {
    if (!props.path) {
      path.value = "";
    }
  }
);

onBeforeMount(() => {
  path.value = props.path;
  convertToLazyLoad();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PopupWindow, {
      dialog: "dialog",
      size: 'sm',
      live: 0,
      fixed: false,
      "fixed-height": false,
      lazyLoad: true,
      moved: _ctx.moved,
      showFooterButton: true,
      onCopyJson: copyJson,
      onLazyLoad: addItemToObject,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
    }, {
      "header-label": _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.title), 1)
      ]),
      main: _withCtx(() => [
        _createVNode(JsonTreeView, {
          data: obj.value,
          tab: 1,
          path: path.value,
          searchable: true,
          "search-data": props.outputData,
          onSelected: _cache[0] || (_cache[0] = ($event: any) => (setPath($event))),
          style: {"width":"100%"}
        }, null, 8, ["data", "path", "search-data"])
      ]),
      _: 1
    }, 8, ["moved"])
  ], 512))
}
}

})